import React from 'react';
import WrapperFormControl from 'components/atoms/WrapperFormControl';
import { InputLabel, MenuItem, FormControl, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    menuPaper: {
        maxHeight: 280,
        marginTop: 50,
    },
}));

const FormControlSelect = ({
    instruction,
    name,
    label,
    value,
    handleChange,
    handleBlur,
    options,
}) => {
    const classes = useStyles();

    return (
        <WrapperFormControl name={name} instruction={instruction}>
            <FormControl fullWidth>
                <InputLabel htmlFor={name}>{label}</InputLabel>
                <Select
                    labelId={name}
                    id={name}
                    value={value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name={name}
                    MenuProps={{ classes: { paper: classes.menuPaper } }}
                >
                    {options.map(({ value, label }) => (
                        <MenuItem key={value} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </WrapperFormControl>
    );
};

export default FormControlSelect;
